import { UUID } from '@/types';
import ColumnName from '@/util/ColumnName';

export const FILTER_PRESETS_TYPE = {
  manual: 'manual',
  prefilled: 'prefilled',
} as const;

export type TFilterPresetsType = keyof typeof FILTER_PRESETS_TYPE;

export type TSavedQueryPreset = {
  seriesId: UUID;
  columnName: ColumnName;
};
